module.exports = __webpack_public_path__ + "img/recurring_white.5d8c3247.svg";